<template>
  <div>
    <el-dialog
      :title="detailTitle"
      :visible.sync="infoDialog.flag"
      :close-on-click-modal="false"
    >
      <div class="block">
        <el-timeline>
          <el-timeline-item
            v-for="(activity, index) in activities"
            :key="index"
            :icon="activity.icon"
            :type="activity.type"
            :color="activity.color"
            :size="activity.size"
            :timestamp="
              activity.auditDate == null
                ? ''
                : activity.auditDate + '\u3000' + activity.auditContent
            "
          >
            {{ activity.auditUserName }}
          </el-timeline-item>
        </el-timeline>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getAuditInfo } from "@/api/enrollment";

export default {
  props: {
    infoDialog: {
      type: Object,
      default: () => {
        return {
          flag: false,
        };
      },
    },
    curUuid: {
      type: String,
      default: () => ""
    }
  },
  data() {
    return {
      size: "small",
      detailTitle: "审核详情",
      activities: [],
      uuid: ""
    };
  },
  methods: {
    // 获取审核列表
    getAuditInfo() {
      getAuditInfo(this.curUuid).then(res => {
        if (res && res.code == 0) {
          let dataArray = res.data;
          if (dataArray != null && dataArray.length > 0) {
            for (var i = 0; i < dataArray.length; i++) {
              if (
                i != dataArray.length - 1 ||
                (i == dataArray.length - 1 &&
                  dataArray[i].auditSchedule != null)
              ) {
                dataArray[i].icon = "el-icon-success";
                dataArray[i].color = "#3A85FF";
              }
              dataArray[i].size = "large";
            }
            this.activities = dataArray;
            this.uuid = this.activities[this.activities.length - 1].uuid;
          }
        }
      });
    },
    // 关闭
    closeFrom() {
      this.$emit("closeDialog");
    }
  },
  created() {
    this.getAuditInfo();
  }
};
</script>

<style lang="scss" scoped></style>
